import React, { useEffect, useState } from "react";
import { Table, Typography } from "antd";

const { Title } = Typography;

function transformData(data) {
  return [
    {
      key: "1",
      metric: "Total",
      risks: data.risks.total_risks,
      opportunities: data.opportunities.total_opportunities,
    },
    {
      key: "2",
      metric: "Mitigated/Realized",
      risks: data.risks.mitigated_risks,
      opportunities: data.opportunities.realized_opportunities,
    },
    {
      key: "3",
      metric: "Archived",
      risks: data.risks.archived_risks,
      opportunities: data.opportunities.archived_opportunities,
    },
    {
      key: "4",
      metric: "Unaddressed/Unrealized",
      risks: data.risks.unaddressed_risks,
      opportunities: data.opportunities.unrealized_opportunities,
    },
    {
      key: "5",
      metric: "Financial Impact",
      risks: data.risks.financial_impact,
      opportunities: data.opportunities.opportunity_impact,
    },
    {
      key: "6",
      metric: "Operational",
      risks: `${data.risks.categories.operational.count} (${data.risks.categories.operational.impact})`,
      opportunities: "-",
    },
    {
      key: "7",
      metric: "Regulatory",
      risks: `${data.risks.categories.regulatory.count} (${data.risks.categories.regulatory.impact})`,
      opportunities: "-",
    },
    {
      key: "8",
      metric: "Market",
      risks: `${data.risks.categories.market.count} (${data.risks.categories.market.impact})`,
      opportunities: `${data.opportunities.categories.market_expansion.count} (${data.opportunities.categories.market_expansion.impact})`,
    },
    {
      key: "9",
      metric: "Innovation",
      risks: "-",
      opportunities: `${data.opportunities.categories.innovation.count} (${data.opportunities.categories.innovation.impact})`,
    },
    {
      key: "10",
      metric: "Partnerships",
      risks: "-",
      opportunities: `${data.opportunities.categories.partnerships.count} (${data.opportunities.categories.partnerships.impact})`,
    },
  ];
}

const ComparativeMetricsTable = ({ dataSource }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (dataSource) {
      setTableData(transformData(dataSource));
    }
  }, [dataSource]);

  const columns = [
    {
      title: "Metric",
      dataIndex: "metric",
      key: "metric",
    },
    {
      title: "Risks",
      dataIndex: "risks",
      key: "risks",
    },
    {
      title: "Opportunities",
      dataIndex: "opportunities",
      key: "opportunities",
    },
  ];

  return (
    <div>
      <Title level={3}>Comparative Metrics Dashboard</Title>
      <Table
        dataSource={tableData}
        columns={columns}
        pagination={false}
        bordered
      />
    </div>
  );
};

export default ComparativeMetricsTable;
